import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logout } from '../../auth/authActions';
import './custom.css';
import ModalHeader from '../modal/modal';
import ModalSeleciona from '../modal/modalSeleciona';
import { Redirect } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getAlertaErro, clearAlertaErro } from '../../controlador_erro/erroActions.js';
import swal from 'sweetalert2';
import moment from 'moment';
import sound from '../sound/alert.mp3';
import manual from '../artifact/Manual_Central_Online_SSAT.pdf';
import axiosInstance from '../../main/axios.js';
import { getList } from '../../controlador_erro_geral/erroGeralActions';
import socketService from '../../services/socketService';

import UserLocal from '../../configuracao/userLocal';
import NotificationModal from './notificationModal';
import TicketSuporteForm from '../../ticket_suporte/ticketSuporteForm';

// Desativar o método direto do socketService para evitar duplicações
const originalToastrWarning = toastr.warning;
toastr.warning = function(title, message, options) {
  // Se a mensagem vier do socketService (contém "Novo erro detectado"),
  // não mostrar o toast pois já é tratado aqui
  if (title === 'Novo erro detectado') {
    return;
  }
  return originalToastrWarning(title, message, options);
};

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.intervalAudioErroGeral = 0;
    this.userInteracted = false; // Flag para rastrear se o usuário já interagiu com a página

    this.state = {
      open: false,
      show: false,
      body: null,
      auxGrup: null,
      auxCont: null,
      auxGrupD: '',
      auxContD: '',
      auxNumCont: '',
      Grup: 'Selecionar',
      Cont: 'Selecionar',
      GrupD: 'Selecionar Grupo Físico',
      ContD: 'Selecionar Controlador',
      numCont: null,
      contLat: null,
      contLong: null,
      anel: 1,
      redirecionarControlador: '',
      loop: 0,
      redirect: false,
      erros: [],
      notifications: [],
      quantidadeNotifications: 0,
      modalNotification: false,
      lastUpdate: Date.now(),
      soundEnabled: false, // Controla se o som pode ser reproduzido
      showTicketModal: false,
      selectedErrorForTicket: null,
    };

    this.clickOk = this.clickOk.bind(this);
    this.modalSelecionaShow = this.modalSelecionaShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.changeControlador = this.changeControlador.bind(this);
    this.changeGrupoFisico = this.changeGrupoFisico.bind(this);
    this.validaSelecao = this.validaSelecao.bind(this);
    this.validaSelecaoOK = this.validaSelecaoOK.bind(this);
    this.handleErrorListUpdate = this.handleErrorListUpdate.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);

    // Referência ao audioElement para reutilizar
    this.audioElement = new Audio(sound);
    this.audioElement.preload = 'auto';
    this.audioElement.volume = 1.0;
    this.audioElement.playbackRate = 1.0;

    // Debug helper
    if (typeof window !== 'undefined') {
      window.diagnosticoNotificacoes = () => {
        return this.debugSocketStatus();
      };

      // Forçar reconexão do socket
      window.reconectarSocket = () => {
        socketService.disconnect();
        setTimeout(() => {
          socketService.connect();
          setTimeout(() => socketService.tryAuthenticate(), 1000);
        }, 1000);
        return 'Reconectando socket...';
      };

      // Resetar apenas o estado das notificações
      window.resetarNotificacoes = () => {
        this.setState({
          notifications: [],
          quantidadeNotifications: 0,
          lastUpdate: Date.now(),
        });
        return 'Estado das notificações resetado.';
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.modalNotification !== prevState.modalNotification) {
      if (this.state.modalNotification) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalAudioErroGeral);
    document.body.classList.remove('modal-open');
    // Remover event listener do WebSocket
    if (this.errorListUpdateHandlerRef)
      socketService.removeEventListener('lista_erros_atualizada', this.errorListUpdateHandlerRef);
  }

  componentDidMount() {
    // Registrar ouvinte APENAS para lista completa de erros atualizada
    // Essa abordagem é mais robusta: detecta novos erros comparando listas
    // e mantém estado sempre sincronizado com o servidor
    const handleListUpdate = (erros, tipoEvento) => {
      this.handleErrorListUpdate(erros, tipoEvento);
    };
    this.errorListUpdateHandlerRef = handleListUpdate;
    socketService.addEventListener('lista_erros_atualizada', this.errorListUpdateHandlerRef);

    // Garantir que o WebSocket esteja conectado
    if (!socketService.connected) {
      socketService.connect();
    }

    // Tentar autenticar se ainda não foi feito
    setTimeout(() => {
      if (socketService.connected && !socketService.isAuthenticated) {
        socketService.tryAuthenticate();
      }
    }, 1000);

    // Expor referência no window para debug
    if (typeof window !== 'undefined') {
      window.navbarComponent = this;

      // Debug helper para testar notificações
      window.testarNotificacoes = () => {
        // Forçar reconexão se necessário
        if (!socketService.connected) {
          socketService.disconnect();
          setTimeout(() => {
            socketService.connect();
            setTimeout(() => socketService.tryAuthenticate(), 1000);
          }, 1000);
        }

        return 'Teste executado - verifique os logs acima';
      };
    }

    // Adicionar listener para detectar interação do usuário
    if (typeof window !== 'undefined') {
      const enableSound = () => {
        // Tentar desbloquear o áudio com uma reprodução silenciosa
        try {
          this.audioElement.muted = true;
          const p = this.audioElement.play();
          if (p && typeof p.then === 'function') {
            p.then(() => {
              this.audioElement.pause();
              this.audioElement.currentTime = 0;
              this.audioElement.muted = false;
              this.setState({ soundEnabled: true });
              this.userInteracted = true;
            }).catch(() => {
              // Mesmo se falhar, habilita a flag após interação do usuário
              this.audioElement.muted = false;
              this.setState({ soundEnabled: true });
              this.userInteracted = true;
            });
          } else {
            // Navegadores sem promise
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
            this.audioElement.muted = false;
            this.setState({ soundEnabled: true });
            this.userInteracted = true;
          }
        } catch (e) {
          this.audioElement.muted = false;
          this.setState({ soundEnabled: true });
          this.userInteracted = true;
        }
      };

      // Eventos que indicam interação do usuário
      window.addEventListener('click', enableSound, { once: true });
      window.addEventListener('pointerdown', enableSound, { once: true });
      window.addEventListener('keydown', enableSound, { once: true });
      window.addEventListener('touchstart', enableSound, { once: true });
      window.addEventListener('mousemove', enableSound, { once: true });
      document.addEventListener(
        'visibilitychange',
        () => {
          if (!document.hidden) {
            enableSound();
          }
        },
        { once: true },
      );
    }
  }

  // Método para debug do status do socket
  debugSocketStatus() {
    const status = socketService.getStatus();
    return status;
  }

  // Função para tocar som com verificação de permissão
  playSound() {
    // Sempre tenta tocar (alguns navegadores permitem autoplay dependendo das permissões do site)
    // Se falhar por NotAllowedError, registramos um retry na próxima interação do usuário

    // Garante que o áudio está carregado e no início
    try {
      this.audioElement.load();
    } catch (e) {}
    this.audioElement.currentTime = 0;
    this.audioElement.muted = false;

    const tryPlay = () => this.audioElement.play();

    return tryPlay().catch(e => {
      if (e && e.name === 'NotAllowedError') {
        // Browser bloqueou: agenda retry na próxima interação do usuário
        const onFirstInteract = () => {
          window.removeEventListener('click', onFirstInteract);
          window.removeEventListener('keydown', onFirstInteract);
          window.removeEventListener('touchstart', onFirstInteract);
          // Tenta novamente após a interação
          try {
            this.audioElement.currentTime = 0;
          } catch (_) {}
          tryPlay().catch(() => {});
        };
        window.addEventListener('click', onFirstInteract, { once: true });
        window.addEventListener('keydown', onFirstInteract, { once: true });
        window.addEventListener('touchstart', onFirstInteract, { once: true });
        // Atualiza flag para refletir que precisamos de interação
        this.setState({ soundEnabled: false });
      }
    });
  }

  // Manipular lista completa de erros recebida via WebSocket
  handleErrorListUpdate(erros, tipoEvento = 'lista_atualizada') {
    if (!Array.isArray(erros)) {
      erros = [];
    }

    // Validar erros - a lista do backend é a fonte da verdade
    const validatedErrors = erros.filter(
      e => e && typeof e === 'object' && e.controlador_id && e.data_erro && e.hora_erro,
    );

    if (validatedErrors.length < erros.length) {
    }

    // Garantir apenas uma notificação por controlador (a mais recente)
    // Removido cache local - confiamos apenas no banco de dados (alerta = 0)
    const uniqueErrors = [];
    const controladorMap = new Map();

    validatedErrors.forEach(erro => {
      const controladorId = erro.controlador_id || erro.numero_controlador;
      const errorDateTime = new Date(`${erro.data_erro} ${erro.hora_erro}`);

      if (!controladorMap.has(controladorId) || errorDateTime > controladorMap.get(controladorId).datetime) {
        controladorMap.set(controladorId, {
          erro: erro,
          datetime: errorDateTime,
        });
      }
    });

    controladorMap.forEach(item => {
      uniqueErrors.push(item.erro);
    });

    // Detectar se há novos erros comparando com estado anterior
    const errosAnteriores = this.state.notifications || [];
    const novosErros = uniqueErrors.filter(erroAtual => {
      return !errosAnteriores.some(
        erroAnterior =>
          erroAnterior.controlador_id === erroAtual.controlador_id &&
          erroAnterior.data_erro === erroAtual.data_erro &&
          erroAnterior.hora_erro === erroAtual.hora_erro &&
          erroAnterior.mensagem === erroAtual.mensagem,
      );
    });

    // Tocar som quando houver novos erros OU no primeiro carregamento com erros
    if (novosErros.length > 0 || (errosAnteriores.length === 0 && uniqueErrors.length > 0)) {
      this.playSound();

      // Toasts removidos - som + sino são suficientes para notificar o usuário
    }

    // Verificar se o usuário prefere alertas em tela
    const mostrarAlertaEmTela = UserLocal.getUserConfig('alerta_tela') === 1;

    if (mostrarAlertaEmTela && uniqueErrors.length > 0) {
      // Mostrar no modal e limpar sino
      this.setState(
        {
          erros: uniqueErrors,
          notifications: [],
          quantidadeNotifications: 0,
          lastUpdate: Date.now(),
        },
        () => {
          this.showMessage();
        },
      );
    } else {
      // Atualizar sino apenas com notificações não lidas e únicas
      this.setState({
        notifications: uniqueErrors,
        quantidadeNotifications: uniqueErrors.length,
        lastUpdate: Date.now(),
      });
    }
  }

  // Método para forçar a renderização de forma otimizada
  forceRender() {
    this.setState({ lastUpdate: Date.now() });
  }

  handleShowTicketModal(error) {
    this.setState({ showTicketModal: true, selectedErrorForTicket: error });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedErrorForTicket: null });
  }

  showMessage() {
    const alerta = this.state.erros;
    let msgHtml = '';

    if (alerta && alerta.length > 0) {
      msgHtml = `
        <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;">
          <!-- Header com contador e botão marcar todas -->
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #e5e7eb;">
            <div style="color: #374151; font-size: 14px; font-weight: 500;">
              ${alerta.length} notificação${alerta.length > 1 ? 'ões' : ''} pendente${alerta.length > 1 ? 's' : ''}
            </div>
            <button id="marcar-todas-lidas" style="
              background: #10b981; 
              color: white; 
              border: none; 
              padding: 8px 16px; 
              border-radius: 6px; 
              font-size: 13px; 
              font-weight: 500; 
              cursor: pointer;
              transition: background-color 0.2s;
            " onmouseover="this.style.backgroundColor='#059669'" onmouseout="this.style.backgroundColor='#10b981'">
              <i class="fa fa-check-double" style="margin-right: 6px;"></i>
              Marcar todas como lidas
            </button>
          </div>
          
          <!-- Tabela Premium -->
          <div style="max-height: 50vh; overflow-y: auto; border-radius: 8px; border: 1px solid #e5e7eb;">
            <table style="width: 100%; border-collapse: collapse; background: white;">
              <thead>
                <tr style="background: #f8fafc; border-bottom: 1px solid #e5e7eb;">
                  <th style="padding: 12px 16px; text-align: center; font-weight: 600; font-size: 13px; color: #374151; border-right: 1px solid #e5e7eb;">Grupo Físico</th>
                  <th style="padding: 12px 16px; text-align: center; font-weight: 600; font-size: 13px; color: #374151; border-right: 1px solid #e5e7eb;">Controlador</th>
                  <th style="padding: 12px 16px; text-align: left; font-weight: 600; font-size: 13px; color: #374151; border-right: 1px solid #e5e7eb;">Notificação</th>
                  <th style="padding: 12px 16px; text-align: center; font-weight: 600; font-size: 13px; color: #374151; border-right: 1px solid #e5e7eb;">Data</th>
                  <th style="padding: 12px 16px; text-align: center; font-weight: 600; font-size: 13px; color: #374151;">Ações</th>
                </tr>
              </thead>
              <tbody>
      `;

      alerta.forEach((a, i) => {
        msgHtml += `
          <tr style="border-bottom: 1px solid #f1f5f9; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f8fafc'" onmouseout="this.style.backgroundColor='white'">
            <td style="padding: 16px; text-align: center; font-size: 14px; font-weight: 500; color: #374151; border-right: 1px solid #f1f5f9;">
              ${a.grupo_fisico_id || '-'}
            </td>
            <td style="padding: 16px; text-align: center; font-size: 14px; font-weight: 600; color: #111827; border-right: 1px solid #f1f5f9;">
              ${a.numero_controlador}
            </td>
            <td style="padding: 16px; text-align: left; font-size: 14px; color: #111827; border-right: 1px solid #f1f5f9;">
              ${a.mensagem}
            </td>
            <td style="padding: 16px; text-align: center; font-size: 13px; color: #6b7280; border-right: 1px solid #f1f5f9;">
              ${moment(a.data_erro).format('DD/MM/YYYY')}<br>
              <span style="font-size: 12px; color: #9ca3af;">${moment(a.hora_erro, 'HH:mm:ss').format('HH:mm')}</span>
            </td>
            <td style="padding: 16px; text-align: center;">
              <div style="display: flex; gap: 8px; justify-content: center;">
                <button id="ler-erro-${i}" style="
                  background: #10b981; 
                  color: white; 
                  border: none; 
                  width: 32px; 
                  height: 32px; 
                  border-radius: 6px; 
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transition: background-color 0.2s;
                " title="Marcar como lida" onmouseover="this.style.backgroundColor='#059669'" onmouseout="this.style.backgroundColor='#10b981'">
                  <i class="fa fa-check" style="font-size: 12px;"></i>
                </button>
                <button id="ticket-erro-${i}" style="
                  background: #f59e0b; 
                  color: white; 
                  border: none; 
                  width: 32px; 
                  height: 32px; 
                  border-radius: 6px; 
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transition: background-color 0.2s;
                " title="Abrir ticket" onmouseover="this.style.backgroundColor='#d97706'" onmouseout="this.style.backgroundColor='#f59e0b'">
                  <i class="fa fa-ticket-alt" style="font-size: 12px;"></i>
                </button>
              </div>
            </td>
          </tr>
        `;
      });

      msgHtml += `
              </tbody>
            </table>
          </div>
        </div>
      `;
    }

    swal({
      title: 'Notificações Pendentes',
      html: msgHtml,
      width: '700px',
      showConfirmButton: false,
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        // Aplicar estilos premium diretamente no modal
        const popup = document.querySelector('.swal2-popup');
        const title = document.querySelector('.swal2-title');

        if (popup) {
          popup.style.borderRadius = '12px';
          popup.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
        }

        if (title) {
          title.style.color = '#111827';
          title.style.fontWeight = '600';
          title.style.fontSize = '20px';
          title.style.marginBottom = '20px';
        }

        // Evento para marcar todas como lidas
        const btnMarcarTodas = document.getElementById('marcar-todas-lidas');
        if (btnMarcarTodas) {
          btnMarcarTodas.addEventListener('click', async () => {
            btnMarcarTodas.disabled = true;
            btnMarcarTodas.innerHTML = '<i class="fa fa-spinner fa-spin" style="margin-right: 6px;"></i>Processando...';

            try {
              await this.marcarNotificacoesComoLidas(alerta);
              swal.close();
            } catch (error) {
              btnMarcarTodas.disabled = false;
              btnMarcarTodas.innerHTML =
                '<i class="fa fa-check-double" style="margin-right: 6px;"></i>Marcar todas como lidas';
            }
          });
        }

        // Utilitário simples de tooltip (sem dependências)
        const attachTooltip = (el, text) => {
          if (!el) return;
          let tip;

          const show = e => {
            // Remove tooltip anterior se existir
            if (tip && tip.parentNode) {
              tip.parentNode.removeChild(tip);
            }

            tip = document.createElement('div');
            tip.textContent = text;
            tip.style.cssText = `
              position: absolute;
              z-index: 99999;
              background: rgba(17,24,39,0.95);
              color: white;
              padding: 6px 10px;
              border-radius: 4px;
              font-size: 12px;
              font-weight: 500;
              pointer-events: none;
              white-space: nowrap;
              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            `;

            document.body.appendChild(tip);

            // Posicionar tooltip
            const rect = el.getBoundingClientRect();
            const tipRect = tip.getBoundingClientRect();

            let top = rect.top - tipRect.height - 8;
            let left = rect.left + rect.width / 2 - tipRect.width / 2;

            // Ajustar se sair da tela
            if (left < 5) left = 5;
            if (left + tipRect.width > window.innerWidth - 5) {
              left = window.innerWidth - tipRect.width - 5;
            }
            if (top < 5) {
              top = rect.bottom + 8; // Mostrar embaixo se não couber em cima
            }

            tip.style.top = top + 'px';
            tip.style.left = left + 'px';
          };

          const hide = () => {
            if (tip && tip.parentNode) {
              tip.parentNode.removeChild(tip);
              tip = null;
            }
          };

          el.addEventListener('mouseenter', show);
          el.addEventListener('mouseleave', hide);
          el.addEventListener('focus', show);
          el.addEventListener('blur', hide);
        };

        // Aguardar um pouco para garantir que o DOM foi renderizado
        setTimeout(() => {
          // Eventos individuais
          alerta.forEach((a, i) => {
            // Adiciona evento para "Marcar como Lida"
            const btnLida = document.getElementById(`ler-erro-${i}`);
            if (btnLida) {
              btnLida.addEventListener('click', () => {
                this.clearAlertaErro(a, true);
              });
              attachTooltip(btnLida, 'Marcar como lida');
            }

            // Adiciona evento para "Abrir Ticket"
            const btnTicket = document.getElementById(`ticket-erro-${i}`);
            if (btnTicket) {
              btnTicket.addEventListener('click', () => {
                this.handleShowTicketModal(a);
                swal.close();
              });
              attachTooltip(btnTicket, 'Abrir ticket');
            }
          });
        }, 100);
      },
    });
  }

  // Método para marcar notificações do modal como lidas
  clearAlertaErro = (alert, isFromModal) => {
    // BUGFIX: Converte para arrow function para garantir o contexto do 'this'.
    // A função agora diferencia se o erro vem do modal 'swal' ou do sino de notificações.
    const getErrorUniqueKey = e =>
      // Notificações do sino podem ter um _timestamp para garantir unicidade.
      e._timestamp || `${e.controlador_id || e.numero_controlador}|${e.data_erro}|${e.hora_erro}|${e.mensagem}`;

    const clickedErrorKey = getErrorUniqueKey(alert);

    // Checa se o alerta a ser removido está na lista de erros do modal 'swal'.
    const isSwalError = this.state.erros.some(e => getErrorUniqueKey(e) === clickedErrorKey);

    // Chama a API para marcar o erro como lido (comportamento comum).
    // Importante: em seguida forçamos um refresh do GET /controladoreserro/:email para
    // evitar que o sino re-apareça até a próxima atualização do websocket.
    const email = UserLocal.getUserConfig('email');
    const request = this.props.clearAlertaErro([alert]);
    if (request && request.payload && typeof request.payload.then === 'function') {
      request.payload
        .then(() => {
          if (!email) return;
          return axiosInstance.get(`/controladoreserro/${email}`);
        })
        .then(resp => {
          if (!resp || !resp.data) return;
          this.handleErrorListUpdate(resp.data, 'refresh_pos_leitura');
        })
        .catch(() => {
          // Mantém comportamento atual em caso de falha: remoção otimista no estado local.
        });
    }

    if (isSwalError) {
      // Se for do modal 'swal', atualiza a lista 'erros' e re-renderiza o modal.
      this.setState(
        prevState => ({
          erros: prevState.erros.filter(e => getErrorUniqueKey(e) !== clickedErrorKey),
        }),
        () => {
          if (this.state.erros.length > 0) {
            this.showMessage();
          } else {
            swal.close();
          }
        },
      );
    } else {
      // Se não for do 'swal', assume que é do sino e atualiza a lista 'notifications'.
      // Utiliza a forma funcional do setState para evitar race conditions ao remover múltiplos itens.
      this.setState(prevState => {
        const newNotifications = prevState.notifications.filter(n => getErrorUniqueKey(n) !== clickedErrorKey);

        return {
          notifications: newNotifications,
          quantidadeNotifications: newNotifications.length,
          lastUpdate: Date.now(),
        };
      });
    }
  };

  // Método para marcar todas as mensagens como lidas
  handleTodasMensagensLidas = async () => {
    // Fazer uma cópia do array de notificações ATUAL DO ESTADO
    const notificacoesCopy = [...this.state.notifications];

    if (notificacoesCopy.length === 0) {
      toastr.info('Informação', 'Não há notificações para marcar como lidas.');
      return;
    }

    // Mostrar loading
    toastr.info('Processando', `Marcando ${notificacoesCopy.length} notificações como lidas...`, {
      position: 'bottom-right',
      timeOut: 2000,
    });

    // Marcar todas as notificações como lidas na API em uma única requisição
    let todasLidasComSucesso = true;
    const startTime = Date.now();

    try {
      const apiStart = Date.now();
      // Envia todas as notificações de uma vez para o backend
      const response = await this.props.clearAlertaErro(notificacoesCopy);
      const apiEnd = Date.now();

      if (!response || !response.payload || response.payload.status !== 200) {
        todasLidasComSucesso = false;
      }
    } catch (e) {
      todasLidasComSucesso = false;
    }

    const stateUpdateStart = Date.now();

    // Atualiza o estado para vazio
    this.setState({
      notifications: [],
      quantidadeNotifications: 0,
      lastUpdate: Date.now(),
    });

    const stateUpdateEnd = Date.now();
    const totalTime = Date.now() - startTime;

    if (todasLidasComSucesso) {
      toastr.success('Sucesso', `${notificacoesCopy.length} notificações marcadas como lidas`, {
        position: 'bottom-right',
      });
    } else {
      toastr.warning('Atenção', 'Algumas notificações podem não ter sido marcadas como lidas no servidor.', {
        position: 'bottom-right',
        timeOut: 5000,
      });
    }
  };

  marcarNotificacoesComoLidas = async notificacoes => {
    if (!notificacoes || notificacoes.length === 0) return;

    try {
      // Envia todas as notificações de uma vez para o backend
      await this.props.clearAlertaErro(notificacoes);

      // Exibir mensagem de sucesso após marcar todas
      toastr.success('Sucesso', 'Notificações marcadas como lidas.', {
        position: 'bottom-right',
      });
    } catch (error) {
      toastr.error('Erro', 'Falha ao marcar notificações como lidas.', {
        position: 'bottom-right',
      });
    }
  };

  setQuantidadeNotifications(iQtd) {}

  clickOpen() {
    this.setState({ open: !this.state.open });
  }

  changeClose() {
    this.setState({ open: false });
  }

  handleClose() {
    if (this.validaSelecao()) {
      this.setState({ show: false });
    }
  }

  changeGrupoFisico(event) {
    let index = event.nativeEvent.target.selectedIndex;

    this.setState({ auxGrup: event.target.value });
    this.setState({ auxGrupD: event.nativeEvent.target[index].text });

    this.setState({ auxCont: null });
    this.setState({ auxContD: 'Selecionar' });
    this.setState({ auxNumCont: 'Selecionar' });
  }

  changeControlador(event, latLon, anel) {
    if (event.target.value !== 'Selecionar') {
      // let index = event.nativeEvent.target.selectedIndex;
      // let contDescricao = event.nativeEvent.target[index].text;
      let index = event.target.selectedIndex;
      let contDescricao = event.target[index].text;
      let numeroCont = contDescricao.split('-');
      let latLonSplit = latLon.split('|');

      this.setState({ auxCont: event.target.value });
      this.setState({ auxContD: event.nativeEvent.target[index].text });
      this.setState({ auxNumCont: parseInt(numeroCont) });
      this.setState({ contLat: latLonSplit[0] });
      this.setState({ contLong: latLonSplit[1] });
      this.setState({ anel: anel });
    }
  }

  modalSelecionaShow() {
    var _cfg = localStorage.getItem('_cfg');

    if (_cfg !== null) {
      _cfg = JSON.parse(_cfg);

      this.setState({ Grup: _cfg.grupo });
      this.setState({ Cont: _cfg.cont });
      this.setState({ GrupD: _cfg.grupoDes });
      this.setState({ ContD: _cfg.contDes });

      this.setState({ auxGrup: this.state.Grup });
      this.setState({ auxCont: this.state.Cont });
      this.setState({ auxGrupD: this.state.GrupD });
      this.setState({ auxContD: this.state.ContD });
    }

    this.setState({
      body: (
        <div>
          <ModalSeleciona
            grupoVal={this.state.Grup}
            controladorVal={this.state.Cont}
            onChangeGrupoFisico={this.changeGrupoFisico}
            onChangeControlador={this.changeControlador}
          />
          {/* <input id="navbarSelecionaLatLon" type="hidden" value="teste" /> */}
        </div>
      ),
    });

    this.setState({ show: true });
  }

  validaSelecao() {
    let grupochildCount = window.$('#seleciona_grupo_fisico')[0].childElementCount;
    let contchildCount = window.$('#seleciona_controlador')[0].childElementCount;

    if (grupochildCount > 1 && (this.state.Grup == null || this.state.Grup === 'Selecionar')) {
      if (this.state.auxGrup === 'Selecionar' || this.state.auxGrup == null) {
        toastr.warning('Alerta', 'Selecione um "Grupo Físico".');
        return false;
      }
    }
    if (contchildCount > 1 && this.state.Cont === 'Selecionar') {
      if (this.state.auxCont === 'Selecionar' || this.state.auxCont == null) {
        toastr.warning('Alerta', 'Selecione um "Controlador".');
        return false;
      }
    }

    return true;
  }

  validaSelecaoOK() {
    if (this.validaSelecao()) {
      if (this.state.auxGrup === 'Selecionar' || this.state.auxGrup == null) {
        toastr.warning('Alerta', 'Selecione um "Grupo Físico".');
        return false;
      }

      if (this.state.auxCont === 'Selecionar' || this.state.auxCont == null) {
        let contchildCount = window.$('#seleciona_controlador')[0].childElementCount;
        if (contchildCount > 1) {
          toastr.warning('Alerta', 'Selecione um "Controlador".');
          return false;
        }
      }

      return true;
    }
    return false;
  }

  clickOk(history) {
    let _cfg = {};
    let _confAtual = localStorage.getItem('_cfg');
    // let grupo_text = window.$('#selGrupoFisicoNavBar span').text();
    _confAtual = JSON.parse(_confAtual);

    if (this.validaSelecaoOK()) {
      if (this.state.auxCont === null && this.state.auxGrup !== this.state.Grup) {
        _cfg = {
          grupo: this.state.auxGrup,
          grupoDes: this.state.auxGrupD,
          cont: 'Selecionar',
          contDes: 'Selecionar Controlador',
          numCont: null,
          contLat: this.state.contLat,
          contLong: this.state.contLong,
          anel: this.state.anel,
          event: 0,
        };

        localStorage.setItem('_cfg', JSON.stringify(_cfg));

        this.setState({ Cont: 'Selecionar' });
        this.setState({ ContD: 'Selecionar Controlador' });
        this.setState({ numCont: null });

        this.setState({ Grup: this.state.auxGrup });
        this.setState({ GrupD: this.state.auxGrupD });

        this.setState({ show: false });
        this.setState({ redirect: true });
        // window.location = "/#/cadcontrolador";
        // window.location = "/";
      } else {
        if (this.state.auxCont === null) {
          _cfg = {
            grupo: this.state.auxGrup,
            grupoDes: this.state.auxGrupD,
            cont: this.state.Cont,
            contDes: this.state.ContD,
            numCont: this.state.numCont,
            contLat: this.state.contLat,
            contLong: this.state.contLong,
            anel: this.state.anel,
            event: 0,
          };
        } else {
          let descCont = this.state.auxContD;

          if (_confAtual) {
            // descCont = (_confAtual.cont === null) ? _confAtual.contDes : this.state.auxContD;
            // descCont = (_confAtual.cont === '') ? _confAtual.contDes : this.state.auxContD;
            // descCont = this.state.auxContD;
            // if (_confAtual.cont === null){
            //     descCont = _confAtual.contDes;
            // } else {
            //     if (_confAtual.cont !== ''){
            //         descCont = _confAtual.contDes;
            //     }
            // }

            descCont = _confAtual.event === 2 ? _confAtual.contDes : this.state.auxContD;
            descCont =
              _confAtual.event === 1 && parseInt(_confAtual.cont) === parseInt(this.state.auxCont)
                ? _confAtual.contDes
                : descCont;
          }

          _cfg = {
            grupo: this.state.auxGrup,
            grupoDes: this.state.auxGrupD, //grupo_text,
            cont: this.state.auxCont,
            contDes: descCont,
            numCont: this.state.auxNumCont,
            contLat: this.state.contLat,
            contLong: this.state.contLong,
            anel: this.state.anel,
            event: 0,
          };

          this.setState({ Cont: this.state.auxCont });
          this.setState({ ContD: descCont });
          this.setState({ numCont: this.state.auxNumCont });
        }

        localStorage.setItem('_cfg', JSON.stringify(_cfg));

        this.setState({ Grup: this.state.auxGrup });
        this.setState({ GrupD: this.state.auxGrupD });
        // this.setState({ GrupD: grupo_text });
        // this.setState({ auxGrupD: grupo_text });

        this.setState({ show: false });
        // recarrega a tela de dashboard, ou vai para a tela de dashboard
        // window.location = "/";
        this.setState({ redirect: true });
      }
    }
  }

  render() {
    // Usar o timestamp apenas para gerar uma classe única para animação
    const notificationTimestamp = this.state.lastUpdate;

    if (this.state.redirect === true) {
      this.setState({ redirect: false });
      return <Redirect to="/cadcontrolador" />;
    }

    const { name, email } = this.props.user;

    let nomeIniciais = name.split(' ');
    if (nomeIniciais.length > 1) {
      nomeIniciais = `${nomeIniciais[0][0]}${nomeIniciais[1][0]}`;
    } else {
      nomeIniciais = `${nomeIniciais[0][0]}${nomeIniciais[0][1]}`;
    }

    const handleOpenModal = e => {
      e.preventDefault();
      this.setState({ modalNotification: true });
    };

    const handleCloseModal = () => {
      this.setState({ modalNotification: false });
    };

    // Calculamos a classe de animação baseada no contador de notificações
    const notificationClass =
      this.state.quantidadeNotifications > 0 ? `shake-animation-${notificationTimestamp % 1000}` : '';

    // Preparar dados para o formulário de ticket
    const { selectedErrorForTicket } = this.state;
    let initialTicketData = null;
    if (selectedErrorForTicket) {
      initialTicketData = {
        titulo: `Erro no Controlador ${selectedErrorForTicket.numero_controlador}`,
        descricao: `Mensagem de Erro: ${selectedErrorForTicket.mensagem}\n\nDetalhes:\n- Data: ${moment(
          selectedErrorForTicket.data_erro,
        ).format('DD/MM/YYYY')}\n- Hora: ${selectedErrorForTicket.hora_erro}\n- Controlador: ${
          selectedErrorForTicket.numero_controlador
        }\n- Grupo Físico: ${selectedErrorForTicket.grupo_fisico_id}`,
        grupo_fisico_id: selectedErrorForTicket.grupo_fisico_id,
        numero_controlador: selectedErrorForTicket.numero_controlador,
        controlador_erro_id: selectedErrorForTicket.id_erro || selectedErrorForTicket.id,
        isFromError: true,
        controlador_id: '',
      };
    }

    return (
      <div className="navbar-custom-menu">
        <ul className="nav navbar-nav">
          <li className={`dropdown user user-menu ${notificationClass}`} key={`notification-${notificationTimestamp}`}>
            <a
              href="#"
              id="notifications"
              className="dropdown-toggle a_button"
              data-toggle="modal"
              onClick={handleOpenModal}
            >
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <i
                  className="fa fa-bell"
                  style={{
                    animation: this.state.quantidadeNotifications > 0 ? 'shake 1.5s ease-in-out infinite' : 'none',
                  }}
                />
                {this.state.quantidadeNotifications > 0 && (
                  <span
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '-10px',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: '50%',
                      padding: '2px 6px',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    {this.state.quantidadeNotifications}
                  </span>
                )}
              </div>
            </a>
          </li>

          <NotificationModal
            showModal={this.state.modalNotification}
            handleCloseModal={handleCloseModal}
            notifications={this.state.notifications}
            clearAlertaErro={this.clearAlertaErro}
            handleTodasMensagensLidas={this.handleTodasMensagensLidas}
          />

          <li className={`dropdown user user-menu`}>
            <a
              href={manual}
              id="downloadManual"
              target="_blank"
              rel="noopener noreferrer"
              className="dropdown-toggle a_button"
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-download'} />
              <span className="hidden-xs">Manual</span> <br />
            </a>
          </li>

          <li className={`dropdown user user-menu`} style={{ display: 'none' }}>
            <a
              href="#"
              id="selGrupoFisicoNavBar"
              className="dropdown-toggle a_button"
              onClick={this.modalSelecionaShow}
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-server'} />
              <span className="hidden-xs">{this.state.GrupD}</span> <br />
            </a>
          </li>

          <li className={`dropdown user user-menu`} style={{ display: 'none' }}>
            <a
              href="#"
              id="selControladorNavBar"
              className="dropdown-toggle a_button"
              onClick={this.modalSelecionaShow}
              aria-expanded={this.state.open ? 'true' : 'false'}
            >
              <i className={'fa fa-hdd'} />
              <span className="hidden-xs">{this.state.ContD}</span> <br />
            </a>
          </li>

          <li
            onMouseLeave={() => this.changeClose()}
            className={`dropdown user user-menu ${this.state.open ? 'open' : ''}`}
          >
            <a
              href="#"
              onMouseEnter={() => this.clickOpen()}
              aria-expanded={this.state.open ? 'true' : 'false'}
              className="dropdown-toggle a_button"
              data-toggle="dropdown"
            >
              <i className={'fa fa-user'} />
              <i className="fa fa-caret-down pull-right" />
            </a>
            <ul className="dropdown-menu dropdown_menu">
              <li className="user-header">
                <p>
                  {name}
                  <small>{email}</small>
                </p>
              </li>
              <li className="user-footer">
                {/* <div className="pull-left">
                                    <a href="#" onClick={this.props.logout} className="btn btn-default btn-sm">
                                        <i className={'fa fa-gear'}></i>
                                        <span className="hidden-xs"> Configuração</span>
                                    </a>
                                </div> */}
                <div className="pull-right">
                  <button onClick={this.props.logout} className="btn btn-default btn-sm">
                    <i className={'fa fa-sign-out-alt'} />
                    <span className="hidden-xs"> Sair</span>
                  </button>
                </div>
              </li>
            </ul>
          </li>
        </ul>

        {this.state.redirecionarControlador}

        <ModalHeader title="Selecionar" show={this.state.show} handleClose={this.handleClose} clickOk={this.clickOk}>
          {this.state.body}
        </ModalHeader>

        {/* Adicionar o formulário de ticket no final para que ele possa ser renderizado */}
        {this.state.showTicketModal && (
          <TicketSuporteForm
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={initialTicketData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({ user: state.auth.user });
const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, getAlertaErro, clearAlertaErro, getList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Navbar);
